export const endpoints = {
  user: {
    login: "user/sign-in",
    getme: "user/get-me",
  },
};
